import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { RouterModule } from '@angular/router';
import { SearchComponent } from './components/search/search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimengModule } from '../primeng/primeng.module';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { TagComponent } from './components/tag/tag.component';
import { DateComponent } from './components/date/date.component';
import { MetricCardComponent } from './components/metric-card/metric-card.component';
import { ReferralsListingComponent } from './components/referrals-listing/referrals-listing.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MultiSelectComponent } from './components/multi-select/multi-select.component';
import { TaskActionsComponent } from './components/task-actions/task-actions.component';
import { ButtonComponent } from './components/button/button.component';
import { OrderPipe } from './pipes/order.pipe';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { SafeurlPipe } from './pipes/safeurl.pipe';
import { SearchPipe } from './pipes/search.pipe';
import { DateformatPipe } from './pipes/dateformat.pipe';
import { ConfirmationPopupComponent } from './components/confirmation-popup/confirmation-popup.component';
import { ConfirmationService } from 'primeng/api';
import { InputComponent } from './components/input/input.component';
import { TextareaComponent } from './components/textarea/textarea.component';
import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
import { IvrCallsComponent } from './components/ivr-calls/ivr-calls.component';
import { InboundCallComponent } from './components/inbound-call/inbound-call.component';
import { DebounceDirective } from './pipes/debounce.pipe';
import { FullCalendarComponent } from './components/full-calendar/full-calendar.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CareTeamComponent } from './components/care-team/care-team.component';
import { SessionAnalyticsComponent } from './components/session-analytics/session-analytics.component';
import { SessionCohortAnalyticsComponent } from './components/session-cohort-analytics/session-cohort-analytics.component';
import { SessionNotesComponent } from './components/session-notes/session-notes.component';
import { SessionRecordingComponent } from './components/session-recording/session-recording.component';
import { CohortSessionDetails } from './components/cohort-session-details/cohort-session-details.component';
import { FileUploadModule } from 'primeng/fileupload';
import { CohortMembersComponent } from './components/cohort-members/cohort-members.component';
import { SessionUpdateConfirmationComponent } from './components/session-update-confirmation/session-update-confirmation.component';
import { ViewImageComponent } from './components/view-image/view-image.component';
import { AddCohortMembersComponent } from './components/add-cohort-members/add-cohort-members.component';
import { NgxSummernoteModule } from 'ngx-summernote';
import { SicCohortSessionDetailsComponent } from './components/sic-cohort-session-details/sic-cohort-session-details.component';
import { TimezonePipe } from './pipes/timezone.pipe';
import { DateString } from './pipes/datestring.pipe';
import { LeadPatientSearchComponent } from './components/lead-patient-search/lead-patient-search.component';
import { MinuteToTimePipe } from './pipes/minuteToTime.pipe';
import { LoadingComponent } from './components/loading/loading.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { NewlinePipe } from './pipes/newline.pipe';
import { CustomReminderComponent } from './components/custom-reminder/custom-reminder.component';
import { HealthDetailsComponent } from './components/health-details/health-details.component';
import { ButtonDropdownComponent } from './components/button-dropdown/button-dropdown.component';
import { SplitButtonComponent } from './components/split-button/split-button.component';
import { ChipComponent } from './components/chip/chip.component';
import { TicketDetailsComponent } from './components/ticket-details/ticket-details.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { NoDataFoundComponent } from './components/no-data-found/no-data-found.component';
import { AddAdminComponent } from './components/admin-tabs/add-admin/add-admin.component';
import { AdminBasicProfileComponent } from './components/admin-tabs/admin-basic-profile/admin-basic-profile.component';
import { AdminWorkingHoursComponent } from './components/admin-tabs/admin-working-hours/admin-working-hours.component';
import { RolesAndPermissionsComponent } from './components/admin-tabs/roles-and-permissions/roles-and-permissions.component';
import { ProgramsAndClientsComponent } from './components/admin-tabs/programs-and-clients/programs-and-clients.component';
import { LeavesComponent } from './components/admin-tabs/leaves/leaves.component';
import { ProfileDetailsComponent } from './components/admin-tabs/profile-details/profile-details.component';
import { FormatChatPipe } from './pipes/formatChat';
import { MealPreferencesPopupComponent } from './components/health-details/components/meal-preferences-popup/meal-preferences-popup.component';
import { AllergiesPopupComponent } from './components/health-details/components/allergies-popup/allergies-popup.component';
import { SelectClientComponent } from './components/select-client/select-client.component';
import { MemberSupportDetailsComponent } from './components/member-support-details/member-support-details.component';
import { IncognitoPipe } from './pipes/incognito.pipe';
import { StripHtmlPipe } from './pipes/strip-html.pipe';
import { DietPreferenceSelectionComponent } from './components/diet-preference-selection/diet-preference-selection.component';
import { PauseParticipationFormComponent } from './forms/pause-participation-form/pause-participation-form.component';
import { DependentMembersComponent } from './components/dependent-members/dependent-members.component';
import { AccessRestrictedComponent } from './components/access-restricted/access-restricted.component';
import { MealPreferenceSelectionComponent } from './meal-preference-selection/meal-preference-selection.component';
import { ApiErrorComponent } from './components/api-error/api-error.component';
import { RecommendProductComponent } from './components/recommend-product/recommend-product.component';
import { CallAttemptHistoryComponent } from './components/call-attempt-history/call-attempt-history.component';
import { CudDetailsModalComponent } from './components/cud-details-modal/cud-details-modal.component';
import { MembersListSkeletonComponent } from './components/members-list-skeleton/members-list-skeleton.component';
import { TasksListSkeletonComponent } from './components/tasks-list-skeleton/tasks-list-skeleton.component';
import { IvrBookAppointmentComponent } from './components/ivr-book-appointment/ivr-book-appointment.component';
import { AiSummaryComponent } from './components/ai-summary/ai-summary.component';
import { AiDocumentationModalComponent } from './components/ai-documentation-modal/ai-documentation-modal.component';
import { AiDocumentationFloatingButtonComponent } from './components/ai-documentation-floating-button/ai-documentation-floating-button.component';
import { ExtractedFieldInputComponent } from './components/extracted-field-input/extracted-field-input.component';
import { ParameterGroupCardComponent } from './components/parameter-group-card/parameter-group-card.component';
import { ReviewExtractedParametersModalComponent } from './components/review-extracted-parameters-modal/review-extracted-parameters-modal.component';
import { JourneyAndNotesComponent } from '../home/modules/member-details/components/journey-and-notes/journey-and-notes.component';
import { InactivityWarningComponent } from './components/inactivity-warning/inactivity-warning.component';
import { WebrtcSoftphoneComponent } from './components/webrtc-softphone/webrtc-softphone.component';

@NgModule({
  declarations: [
    SpinnerComponent,
    HeaderComponent,
    SidebarComponent,
    SearchComponent,
    DropdownComponent,
    TagComponent,
    DateComponent,
    MetricCardComponent,
    ReferralsListingComponent,
    MultiSelectComponent,
    TaskActionsComponent,
    ButtonComponent,
    OrderPipe,
    ErrorMessageComponent,
    SafeurlPipe,
    SearchPipe,
    DateformatPipe,
    ConfirmationPopupComponent,
    InputComponent,
    TextareaComponent,
    AutocompleteComponent,
    DebounceDirective,
    FullCalendarComponent,
    IvrCallsComponent,
    InboundCallComponent,
    CareTeamComponent,
    SessionAnalyticsComponent,
    SessionCohortAnalyticsComponent,
    SessionNotesComponent,
    SessionRecordingComponent,
    CohortSessionDetails,
    CohortMembersComponent,
    SessionUpdateConfirmationComponent,
    ViewImageComponent,
    AddCohortMembersComponent,
    SicCohortSessionDetailsComponent,
    TimezonePipe,
    DateString,
    LeadPatientSearchComponent,
    MinuteToTimePipe,
    LoadingComponent,
    CheckboxComponent,
    NewlinePipe,
    CustomReminderComponent,
    HealthDetailsComponent,
    ButtonDropdownComponent,
    SplitButtonComponent,
    ChipComponent,
    TicketDetailsComponent,
    SafeHtmlPipe,
    NoDataFoundComponent,
    AddAdminComponent,
    AdminBasicProfileComponent,
    AdminWorkingHoursComponent,
    RolesAndPermissionsComponent,
    ProgramsAndClientsComponent,
    LeavesComponent,
    ProfileDetailsComponent,
    FormatChatPipe,
    MealPreferencesPopupComponent,
    AllergiesPopupComponent,
    SelectClientComponent,
    MemberSupportDetailsComponent,
    IncognitoPipe,
    StripHtmlPipe,
    DietPreferenceSelectionComponent,
    PauseParticipationFormComponent,
    DependentMembersComponent,
    AccessRestrictedComponent,
    MealPreferenceSelectionComponent,
    ApiErrorComponent,
    RecommendProductComponent,
    CallAttemptHistoryComponent,
    CudDetailsModalComponent,
    MembersListSkeletonComponent,
    TasksListSkeletonComponent,
    IvrBookAppointmentComponent,
    AiSummaryComponent,
    AiDocumentationModalComponent,
    AiDocumentationFloatingButtonComponent,
    ExtractedFieldInputComponent,
    ParameterGroupCardComponent,
    ReviewExtractedParametersModalComponent,
    JourneyAndNotesComponent,
    InactivityWarningComponent,
    WebrtcSoftphoneComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    PrimengModule,
    MatMenuModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    FileUploadModule,
    NgxSummernoteModule,
  ],
  exports: [
    SpinnerComponent,
    HeaderComponent,
    SidebarComponent,
    SearchComponent,
    DropdownComponent,
    TagComponent,
    DateComponent,
    MetricCardComponent,
    ReferralsListingComponent,
    MultiSelectComponent,
    TaskActionsComponent,
    OrderPipe,
    ButtonComponent,
    ErrorMessageComponent,
    SafeurlPipe,
    SearchPipe,
    DateformatPipe,
    ConfirmationPopupComponent,
    InputComponent,
    TextareaComponent,
    AutocompleteComponent,
    IvrCallsComponent,
    InboundCallComponent,
    DebounceDirective,
    FullCalendarComponent,
    CareTeamComponent,
    SessionAnalyticsComponent,
    SessionCohortAnalyticsComponent,
    SessionNotesComponent,
    SessionRecordingComponent,
    CohortSessionDetails,
    CohortMembersComponent,
    SessionUpdateConfirmationComponent,
    ViewImageComponent,
    NgxSummernoteModule,
    SicCohortSessionDetailsComponent,
    TimezonePipe,
    DateString,
    LeadPatientSearchComponent,
    MinuteToTimePipe,
    LoadingComponent,
    CheckboxComponent,
    NewlinePipe,
    HealthDetailsComponent,
    ButtonDropdownComponent,
    SplitButtonComponent,
    ChipComponent,
    TicketDetailsComponent,
    SafeHtmlPipe,
    NoDataFoundComponent,
    FormatChatPipe,
    MealPreferencesPopupComponent,
    AllergiesPopupComponent,
    SelectClientComponent,
    MemberSupportDetailsComponent,
    IncognitoPipe,
    StripHtmlPipe,
    DietPreferenceSelectionComponent,
    PauseParticipationFormComponent,
    DependentMembersComponent,
    AccessRestrictedComponent,
    MealPreferenceSelectionComponent,
    ApiErrorComponent,
    CallAttemptHistoryComponent,
    CudDetailsModalComponent,
    MembersListSkeletonComponent,
    TasksListSkeletonComponent,
    IvrBookAppointmentComponent,
    AiSummaryComponent,
    AiDocumentationModalComponent,
    AiDocumentationFloatingButtonComponent,
    ExtractedFieldInputComponent,
    ParameterGroupCardComponent,
    ReviewExtractedParametersModalComponent,
    JourneyAndNotesComponent,
    InactivityWarningComponent,
    WebrtcSoftphoneComponent
  ],
  providers: [ConfirmationService, NgbActiveModal]
})
export class SharedModule { }
